import { useEffect, useState } from "react"
import { Link } from "react-router-dom";
import ApiService from "../ApiService";
import { getToken } from "../LocalStorage";

interface iConfigureCuenta{

}
export default function ConfigureCuenta(props: iConfigureCuenta){
    const [configurado, setConfigurado] = useState(false);

    const getMe = () => {
        const token = getToken() || '';
        (new ApiService()).getMe(token).then((data1:any) => {
            const dataUser = data1.data;
            console.log("DataUser:", dataUser);
            if ( dataUser?.pathRel === null){
                setConfigurado(false);
                return;
            }

            if ( dataUser?.apodo?.substr(0,7) === "usuario"){
                setConfigurado(false);
                return;
            }

            setConfigurado(true);

        }).catch(err => {
            setConfigurado(false);
        })
    }

    useEffect(()=>{
        getMe();
    },[])


    return <div>{
            (configurado == true)?
                <></>
            :<div style={{width:'100%', alignItems: 'center',marginBottom: 10}}>
                    <Link to="/ndv/settings">
                        <div style={{ width: '100%'}}>
                            <h2 style={{textAlign: 'center', textDecorationLine: "underline"}}>Configure su apodo e imagen de perfil</h2>
                        </div>
                    </Link>
             </div>
        }</div>  
}